import { render, staticRenderFns } from "./RunProductCharacteristics.vue?vue&type=template&id=56af52f8&scoped=true&"
import script from "./RunProductCharacteristics.vue?vue&type=script&lang=js&"
export * from "./RunProductCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./RunProductCharacteristics.vue?vue&type=style&index=0&id=56af52f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56af52f8",
  null
  
)

export default component.exports